import gateway from '@/api/gateway/gateway'
import store from '@/store' 

const BASE_SUCCESS_STATUS_CODE = '200'

export const $GET = ({ EndPoint, QueryParameters }) => {
  let parameterURL = ''
  if (QueryParameters !== null && Object.keys(QueryParameters).length > 0) {
    Object.keys(QueryParameters).forEach((parameterKey, index) => {
      parameterURL +=
        index === 0
          ? `?${parameterKey}=${QueryParameters[parameterKey]}`
          : `&${parameterKey}=${QueryParameters[parameterKey]}`
    })
  }
  if (parameterURL != '') {
    EndPoint = `${EndPoint}${parameterURL}`
  }
  store.commit('setLoading', true);
  return new Promise((resolve, reject) => {
    gateway
      .get(EndPoint)
      .then(
        (response) => {
          const responseData = response.data
          responseData.IsSuccess =
            responseData.StatusCode === BASE_SUCCESS_STATUS_CODE
          store.commit('setLoading', false);
          return resolve(responseData)
        },
        (error) => {
          store.commit('setLoading', false);
          return reject(error)
        }
      )
      .catch((error) => {
        store.commit('setLoading', false);
        return reject(error)
      })
  })
}

export const $POST = ({ EndPoint, BodyData = null }) =>
  new Promise((resolve, reject) => {
    store.commit('setLoading', true);
    gateway
      .post(EndPoint, BodyData)
      .then(
        (response) => {
          const responseData = response.data
          responseData.IsSuccess =
            responseData.StatusCode === BASE_SUCCESS_STATUS_CODE
          store.commit('setLoading', false);
          return resolve(responseData)
        },
        (error) => {
          store.commit('setLoading', false);
          return reject(error)
        }
      )
      .catch((error) => {
        store.commit('setLoading', false);
        return reject(error)
      })
  })
